import React from 'react'
import styled from 'styled-components'
import { AppBar, Tabs, Tab, Typography, withStyles, Card, CardContent } from '@material-ui/core'

import { Add, List } from './Plan'

function TabContainer(props) {
  const { Component, ...rest } = props
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      <Component {...rest}/>
    </Typography>
  )
}

const MainCard = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

const styles = theme => ({
  root: {
    flexGrow: 1,
    margin: '10px 0',
    backgroundColor: theme.palette.background.paper,
  },
  appbar: {
    maxWidth: '100%',
    width: '500px',
    margin: 'auto'
  },
  card: {
    width: '500px',
    maxWidth: '100%',
    maxHeight: 500,
    overflow: 'scroll',
  },
})

class SimpleTabs extends React.Component {
  state = {
    value: 0,
  }

  handleChange = (e, value) => {
    this.setState({ value })
  }

  render() {
    const { classes, plans, ...rest } = this.props
    const { value } = this.state

    return (
      <div className={classes.root}>
        <AppBar position="static" color="default" className={classes.appbar}>
          <Tabs value={value} indicatorColor="primary" textColor="primary" onChange={this.handleChange}>
            <Tab label="List" />
            <Tab label="Add" />
          </Tabs>
        </AppBar>
        <MainCard className="login">
          <Card className={classes.card}>
            <CardContent>
              {value === 0 && <TabContainer Component={List} plans={plans}/>}
              {value === 1 && <TabContainer Component={Add} {...rest}/>}
            </CardContent>
          </Card>
        </MainCard>
      </div>
    )
  }
}

export default withStyles(styles)(SimpleTabs)


// WEBPACK FOOTER //
// ./src/components/PlanField.jsx